import Cookies from 'js-cookie';
import router from 'next/router';
import { b2G1_recover_key } from '../Constants/AddressPage';
import { getPublicUrl } from '../appconfig';
import {
  showPopupParam,
  showWidgetQueryParam,
} from '../components/CartOverlayContainer/Cart/Constants';
import {
  cartPopupFlow,
  getBranchLink,
  getScreenName,
  isAndroidAppUser,
  isIOSAppUser,
  showNewCartFlow,
} from './helper';
import { getRouterLocale } from './i18Utils/constant';
import { getWebUserType } from './getWebUserType';
import { fireEvent } from './fireEvent';

const publicUrl = getPublicUrl();

export const redirectToExternalSite = (path, searchParams = '') => {
  if (typeof window !== 'undefined') {
    window.open(path + window?.location?.search + searchParams, '_blank');
  }
};

export const redirectToMyloUrl = (path) => {
  if (typeof window !== 'undefined') {
    window.location.href = publicUrl + path + window?.location?.search;
  }
};

export const downloadAppHandler = (fireClickEvent = true) => {
  if (fireClickEvent)
    fireEvent({
      category: 'clicked_download_app',
      screen_name: getScreenName(),
      name: 'google_play',
      deeplink_value: getBranchLink(),
      page_url: window?.location?.href,
    });
  window.location.href = getBranchLink();
};

export const downloadAppleAppHandler = () => {
  fireEvent({
    category: 'clicked_download_app',
    screen_name: getScreenName(),
    name: 'app_store',
    deeplink_value: getBranchLink(),
    page_url: window?.location?.href,
  });
  window.location.href = getBranchLink();
};

export const stringReplaceQuestion = (url) => {
  let modifiedUrl = url;
  if (modifiedUrl.includes('?')) {
    modifiedUrl = modifiedUrl.replace('?', '');
  }
  return modifiedUrl;
};
// poup styles
export const customStyles = (top, right, bottom, left, desktopLogin) => {
  let customStyle = {
    content: {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      textAlign: desktopLogin ? 'left' : 'center',
      padding: 0,
      maxWidth: desktopLogin ? '800px' : '1190px',
      width: '100%',
      margin: 'auto',
      borderRadius: desktopLogin ? '38px' : '14px 14px 0 0',
      overflow: 'inherit',
      left: '0',
      right: '0',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.5)',
      zIndex: 9999,
    },
  };
  return customStyle;
};
export const SharePopupStyle = (top, right, bottom, left) => {
  let customStyle = {
    content: {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      textAlign: 'center',
      padding: 0,
      maxWidth: '500px',
      width: '100%',
      margin: 'auto',
      overflow: 'inherit',
      left: '0',
      right: '0',
      border: 'none',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.5)',
      zIndex: 9999,
    },
  };
  return customStyle;
};
export const scrollableBottomSheet = (top, right, bottom, left, height) => {
  let customStyle = {
    content: {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      padding: 0,
      maxWidth: '500px',
      width: '100%',
      margin: 'auto',
      overflowY: 'auto',
      left: '0',
      right: '0',
      border: 'none',
      height: height || '90%',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.5)',
      zIndex: 9999,
    },
  };
  return customStyle;
};
export const bottomStylePopup = (top, right, bottom, left) => {
  let customStyle = {
    content: {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      textAlign: 'center',
      padding: 0,
      maxWidth: '720px',
      width: 'auto',
      margin: 'auto',
      borderRadius: '8px 8px 0 0',
      overflow: 'inherit',
      left: '0',
      right: '0',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.5)',
      zIndex: 999,
    },
  };
  return customStyle;
};
export const SizePopupStyle = (top, right, bottom, left) => {
  let customStyle = {
    content: {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      textAlign: 'center',
      transform: 'translate(-50%,0)',
      padding: 0,
      width: 'auto',
      overflow: 'inherit',
      maxWidth: 'auto',
      margin: 'auto',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.3)',
      zIndex: 99,
    },
  };
  return customStyle;
};
export const SizeStyles = (top, right, bottom, left) => {
  let customStyle = {
    content: {
      left: left,
      right: right,
      bottom: bottom,
      top: top,
      textAlign: 'center',
      padding: 0,
      maxWidth: '1190px',
      width: '100%',
      margin: 'auto',
      overflow: 'inherit',
      left: '0',
      right: '0',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.3)',
      zIndex: 999,
    },
  };
  return customStyle;
};

export const BogoPopup = (top, right, bottom, left) => {
  let customStyle = {
    content: {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      textAlign: 'center',
      padding: 0,
      maxWidth: '900px',
      width: '100%',
      margin: 'auto',
      overflow: 'inherit',
      left: '0',
      right: '0',
      borderRadius: '8px',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.3)',
      zIndex: 999,
    },
  };
  return customStyle;
};

export const CenterStylePopup = (top, right, bottom, left) => {
  let CenterStylePopup = {
    content: {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      textAlign: 'center',
      padding: 0,
      transform: 'translate(-50%, -50%)',
      width: '95%',
      overflow: 'inherit',
      maxWidth: '600px',
      margin: 'auto',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.3)',
      zIndex: 99,
    },
  };
  return CenterStylePopup;
};
export const CenterPopupStyle = (top, right, bottom, left, bg, br) => {
  let CenterStylePopup = {
    content: {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      textAlign: 'center',
      padding: 0,
      transform: 'translate(-50%, -50%)',
      width: 'auto',
      overflow: 'inherit',
      maxWidth: 'auto',
      margin: 'auto',
      borderRadius: br || '4px',
    },
    overlay: {
      background: bg || 'rgba(0, 0, 0, 0.3)',
      zIndex: 99,
    },
  };
  return CenterStylePopup;
};

export const HealthCenterStylePopup = (top, right, bottom, left) => {
  let CenterStylePopup = {
    content: {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      padding: 0,
      transform: 'translate(-50%, -50%)',
      width: '95%',
      overflow: 'inherit',
      maxWidth: '600px',
      margin: 'auto',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.3)',
      zIndex: 99,
    },
  };
  return CenterStylePopup;
};

export const InstallAppPopup = (top, right, bottom, left) => {
  let InstallAppPopup = {
    content: {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      textAlign: 'center',
      padding: 0,
      transform: 'translate(-50%, -50%)',
      width: '95%',
      overflow: 'inherit',
      maxWidth: '820px',
      margin: 'auto',
      borderRadius: '16px',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.3)',
      zIndex: 99,
    },
  };
  return InstallAppPopup;
};

export const FormStylePopup = (top, right, bottom, left, bg, width) => {
  let CenterStylePopup = {
    content: {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      textAlign: 'center',
      padding: 0,
      transform: 'translate(-50%, -50%)',
      width: width || '95%',
      overflow: 'inherit',
      maxWidth: '500px',
      margin: 'auto',
    },
    overlay: {
      background: bg || 'rgba(0, 0, 0, 0.3)',
      zIndex: 99,
    },
  };
  return CenterStylePopup;
};

export const UserVideoStylePopup = (top, right, bottom, left) => {
  let CenterStylePopup = {
    content: {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      textAlign: 'center',
      padding: 0,
      transform: 'translate(-50%, -50%)',
      width: '100%',
      overflow: 'inherit',
      maxWidth: '900px',
      margin: 'auto',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.3)',
      zIndex: 9999,
    },
  };
  return CenterStylePopup;
};

export const customStyledPopup = (top, right, bottom, left) => {
  let customStyledPopup = {
    content: {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      textAlign: 'center',
      padding: 0,
      transform: 'translate(-50%, -50%)',
      width: '290px',
      overflow: 'inherit',
      margin: 'auto',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.3)',
      zIndex: 99,
    },
  };
  return customStyledPopup;
};

export const chatHandler = () => {
  location.href = 'mailto:shop@mylofamily.com';
};
export const callHandler = (text, phoneNumberUrl) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: 'ivf_static_next',
    user_type: getWebUserType(),
    id: 379,
    sku_type: 'lead',
    cta: text ? text : 'NA',
    name: 'Get Free Consultation on IVF',
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
  });
  location.href = phoneNumberUrl;
};

export const callCustomerCare = () => {
  location.href = 'tel:0804-719-0745';
};

export const navigateToCartPage = (pageLocation = null) => {
  if (showNewCartFlow()) {
    const params = new URLSearchParams(window.location.search);
    const fakeParams = new URLSearchParams(window.location.search);
    switch (fakeParams.get('cart')) {
      case 'true':
        fakeParams.set('cart', 'side');
        break;
      case 'side':
        fakeParams.set('cart', 'true');
        break;
      default:
        fakeParams.set('cart', 'true');
    }
    // if (Cookies.get("currentDay") && pageLocation != "B2G1") {
    //     fakeParams.set("coupon", "FREEGIFT");
    // }
    const recover_data = params.get('key');
    const b2g1_recover = params.get(b2G1_recover_key);
    if (recover_data) {
      params.delete('key');
      fakeParams.delete('key');
      Cookies.set('recover_data', recover_data);
    }
    if (b2g1_recover) {
      params.delete(b2G1_recover_key);
      fakeParams.delete(b2G1_recover_key);
    }
    if (cartPopupFlow()) {
      params.set(showPopupParam, true);
      fakeParams.set(showPopupParam, true);
    }

    params.set(showWidgetQueryParam, true);
    let fakePath = window.location.pathname + '?' + fakeParams;
    router.push(window?.location?.pathname + '?' + params, fakePath, {
      shallow: true,
      scroll: false,
    });
    if (cartPopupFlow()) {
      params.delete(showPopupParam);
      fakeParams.delete(showPopupParam);
      fakePath = window.location.pathname + '?' + fakeParams;
      router.push(window?.location?.pathname + '?' + params, fakePath, {
        shallow: true,
        scroll: false,
      });
    }
  } else if (typeof window !== 'undefined') {
    window.location.href = publicUrl + `/cart` + window?.location?.search;
  }
};

export const navigateToOrderlistPage = () => {
  if (typeof window !== 'undefined') {
    window.location.href = publicUrl + `/my-orders` + window?.location?.search;
  }
};

export const navigateToOrdersummaryPage = () => {
  if (typeof window !== 'undefined') {
    window.location.href =
      publicUrl + `/store/placeorder` + window?.location?.search;
  }
};

export const navigateToChangeAddressPage = () => {
  router.push(`/changeaddress` + window.location.search, '', {
    locale: getRouterLocale(router),
  });
};
export const navigateToNewAddressPage = (addParams) => {
  let params = '';
  params = new URLSearchParams(window.location.search);
  if (addParams) {
    params.set('backPopup', true);
  }
  // params.delete(showPopupParam);
  // router.push(window.location.pathname + "?" + params);
  router.push(`/address/new` + '?' + params, '', {
    locale: getRouterLocale(router),
  });
};

export const navigateToCategoryPage = (webUrl) => {
  if (typeof window !== 'undefined') {
    router.push(webUrl + window.location.search, '', {
      locale: getRouterLocale(router),
    });
  }
};

export const navigateToStore = () => {
  router.push(`/store` + window.location.search);
};
export const navigateTogeneralItemPages = (key) => {
  router.push(`/store/${key}` + window.location.search, undefined, {
    scroll: false,
    shallow: true,
  });
};
export const openBogoPopup = () => {
  const params = new URLSearchParams(window.location.search);
  params.set('bogopopup', true);
  router.push(window?.location?.pathname + '?' + params, undefined, {
    scroll: false,
    shallow: true,
  });
};
export const navigateToCheckoutPage = (router, addParams) => {
  if (typeof window !== 'undefined') {
    let params = '';
    params = new URLSearchParams(window.location.search);
    if (addParams) {
      params.set('paymentBackPopup', true);
    }
    if (
      router &&
      // getWebUserType() == "A" &&
      !isAndroidAppUser() &&
      !isIOSAppUser()
    ) {
      router.push(`/store/payment` + '?' + params, '', {
        locale: getRouterLocale(router),
      });
    } else {
      window.location.href = publicUrl + `/payment` + window?.location?.search;
    }
  }
};

export const getUserTypeAndDevice = () => {
  // if (isAndroidAppUser() || isIOSAppUser() || getWebUserType() === "A") {
  //     return true;
  // } else {
  //     return false;
  // }
  return true;
};
const fireNavigationEvent = (url) => {
  fireEvent({
    category: 'navigation_occurred',
    screen_name: 'payment',
    url: url.substring(0, 98),
    support_variable: JSON.stringify({
      guid: Cookies.get('token') || '',
    }),
  });
};
export const navigateToOrderSuccessNew = (path, router) => {
  let redirectUrlNext = '/store/ordersuccess/' + path + window.location.search;
  let redirectUrlReact =
    getPublicUrl() + '/store/order/' + path + window.location.search;
  if (getUserTypeAndDevice()) {
    fireNavigationEvent(redirectUrlReact);
    window.location.href = redirectUrlReact;
  } else {
    fireNavigationEvent(redirectUrlNext);
    router.push(redirectUrlNext);
  }
};
export const navigateToLoginPage = (
  addParams = false,
  fomAddress = false,
  fromOrder = false,
  needHelp = false,
) => {
  const params = new URLSearchParams(window.location.search);
  if (fomAddress) {
    if (addParams) {
      params.set('guestPopup', true);
    }
    params.set('fromAddress', true);
  }
  if (fromOrder) {
    params.set('fromOrder', true);
  }
  if (needHelp) {
    params.set('needHelp', true);
  }
  router.push(`/login` + '?' + params, undefined, {
    scroll: false,
    shallow: true,
  });
};
